import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    showSidenav: false,
  }),
  actions: {
    openSidenav() {
      this.showSidenav = true
    },
    closeSidenav() {
      this.showSidenav = false
    },
    toggleSidenav() {
      this.showSidenav = !this.showSidenav
    },
  },
})
